module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"All application notices"},"et":{"title":"All application notices"},"ru":{"title":"All application notices"}}')
  delete Component.options._Ctor
}
